import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@mui/material';

export const ConfirmationDialog = ({
  header = 'Alert',
  openDialog,
  onCloseDialog,
  actionButtonOne,
  actionButtonTwo,
  textButtonOne,
  textButtonTwo,
  title,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={openDialog}
      onClose={() => !isLoading && onCloseDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">{header}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-line' }}>
          {title}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {textButtonTwo && actionButtonTwo && (
          <Btn
            onClick={() => actionButtonTwo(false)}
            variant="outlined"
            disabled={isLoading}
          >
            {textButtonTwo}
          </Btn>
        )}
        <Btn onClick={() => actionButtonOne()} disabled={isLoading}>
          {isLoading ? 'Loading...' : textButtonOne}
        </Btn>
      </DialogActions>
    </Dialog>
  );
};

const Btn = styled(Button)`
  border: solid 1px #115a79;
  text-transform: none !important;
  font-weight: 700;
  font-size: 16px;
`;
